<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import CreateStok from "./create_stock.vue"

export default {
  page: {
    title: "Stok Yönetimi",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    CreateStok,
  },
  data() {
    return { 
            list: {},
            title: "STOK YÖNETİMİ",
            items: [
            {
                text: "ANASAYFA",
                href: "/",
            },
            {
                text: "STOK YÖNETİMİ",
                active: true,
            },
            ],
            isLoading: false,
            rows: [],
            totalRecords: 0,
            serverParams: {
            columnFilters: {},
            sort: [
                {
                    field: '',
                    type: '',
                },
            ],
            page: 1,
            perPage: 50,
            },
            currentPage: 0,
            pageLength: 0,
            url: "/stock",
            paginationOptions: {
            enabled: true,
            dropdownAllowAll: false,
            perPage: 50,
            setCurrentPage: 1,
            perPageDropdown: [50, 100, 200],
            nextLabel: 'Sonraki',
            prevLabel: 'Önceki',
            rowsPerPageLabel: 'Kayıt Göster',
            ofLabel: 'of',
            pageLabel: 'sayfa', // for 'pages' mode
            infoFn: params => `Bulunduğun Sayfa ${params.currentPage}`,
            },
            selectOptions: {
                enabled: false,
                selectOnCheckboxOnly: false,
                selectionInfoClass: 'custom-class',
                selectionText: 'adet kayıt seçildi',
                clearSelectionText: 'seçimi iptal et',
                disableSelectInfo: false,
                selectAllByGroup: false,
            },
            columns: [
                {
                    label: 'Grup',
                    field: this.group_id,
                    sortable: false,
                },
                {
                    label: 'Ürün Hizmeti',
                    field: 'stock_group_name',
                    filterOptions: {
                        enabled: true,
                        filterDropdownItems: [],
                    },
                },
                {
                    label: 'Miktar',
                    field: 'amount',
                    sortable: false,
                },
                {
                    label: 'Birim',
                    field: 'unit',
                    sortable: false,
                },
            ],
            openModal:0
        };
    },
    mounted() {
        this.loadItems()
     },
    methods: {
        group_id(rowObj) {
            const data = {
                "an" : "Anten",
                "ka" : "Kablo",
                "mo" : "Modem",
                "sm" : "Sarf Malzeme",
            }
            return  data[rowObj.group_id]
        },
        updateParams(newProps) {
            this.serverParams = { ...this.serverParams, ...newProps }
        },
        onPageChange(params) {
            this.updateParams({ page: params.currentPage })
            this.loadItems()
        },
        onPerPageChange(params) {
            this.updateParams({ perPage: params.currentPerPage })
            this.loadItems()
        },
        onSortChange(params) {
            this.updateParams({ sort: params})
            this.loadItems()
        },
        onColumnFilter(params) {
            this.updateParams(params)
            this.loadItems()
        },
        loadItems() {
            this.getFromServer(this.serverParams).then(response => {
                this.totalRecords = response.totalRecords
                this.pageLength = response.pageLength
                this.currentPage = response.currentPage
                this.rows = response.rows
            })
        },
        getFromServer() {
            return new Promise((resolve, reject) => {
                this.$http.post(this.url, this.serverParams)
                .then(res => {
                    resolve({
                    rows: res.data.data,
                    totalRecords: res.data.total,
                    pageLength: res.data.last_page,
                    currentPage: res.data.current_page,
                    })
                })
                .catch(error => {
                    reject(error)
                })
            })
        },
        onSearch(params) {
            this.updateParams(params)
            this.loadItems()
        },
        create(){
            this.openModal += 1
            this.$parent.$bvModal.show('modal-scoped')
        },
    },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <CreateStok 
        :data="openModal" 
    />

    <div class="row">     
        <div class="col-12">
            <vue-good-table
                mode="remote"
                :total-rows="totalRecords"
                :columns="columns"
                :rows="rows"
                :search-options="{
                    enabled: false,
                    placeholder: 'Arama İçin Enter\'a Basınız'
                  }"
                @on-search="onSearch"
                :select-options="selectOptions"
                :pagination-options="paginationOptions"
                :is-loading.sync="isLoading"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange">
                <template slot="loadingContent">
                  <div>Yükleniyor</div>
                </template>
                <div slot="table-actions">
                    <button 
                    class="btn btn-success btn-sm" 
                    style="margin-right:10px;margin-top:2px" 
                    type="button" 
                    @click="create()"
                    ><i class="fa fa-plus"></i> Stoğa Yeni Ürün Ekle
                    </button>
                </div>
            </vue-good-table>
        </div>
    </div>
  </Layout>
</template>
